module.exports = __webpack_public_path__ + "static/img/mobile-2.a3b43c31.png";